import React, { useEffect, useState } from "react";
import { GetCustomerSupport } from "Services/OtherApis";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import toast from "react-hot-toast";
import { isArabic } from "constants/isArabic";
import moment from "moment";
function CustomerQueries() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  const [language, setSelectedLanguage] = useState(isRTL ? "ar" : "en");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getAllCustomerSupport();
  }, []);

  async function getAllCustomerSupport(value) {
    setLoading(true);
    try {
      const res = await GetCustomerSupport(language);

      setData(res?.data || []); // Ensure data is always an array
    } catch (e) {
      console.error("Error fetching jobs:", e);
    } finally {
      setLoading(false);
    }
  }

  const exportToExcel = () => {
    const headers = [
      "Name",
      "Email",
      "Phone",
      "Subject",
      "National Id",
      "Nature Of Communication",
      "Date",
      "Message",
    ];

    const formattedData = data.map(({ updatedAt, __v, _id, ...rest }) => ({
      Name: rest?.name,
      Email: rest?.email,
      Phone: rest.phone,
      Subject: rest.subject,
      "National Id": rest.nationalId,
      "Nature Of Communication": rest.natureOfCommunication,
      Date: moment(rest.createdAt).format("LLL"),
      Message: rest.message,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData, {
      header: headers,
    });

    // Auto-adjust column widths based on content length
    const wscols = headers.map((header) => {
      const maxLength = formattedData.reduce((max, row) => {
        return row[header] ? Math.max(max, row[header].toString().length) : max;
      }, header.length);
      return { wch: maxLength + 5 }; // Adding padding
    });

    worksheet["!cols"] = wscols;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customer_Queries");
    XLSX.writeFile(workbook, "Customer_Queries.xlsx");
  };

  return (
    <div className="w-full">
      <div className="flex justify-between items-center">
        <div className="font-semibold text-xl  tracking-wide">
          {t("Customer Queries")}
        </div>
        {data?.length > 0 && (
          <button
            onClick={exportToExcel}
            className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-blue-600"
          >
            {t("Export to Excel")}
          </button>
        )}
      </div>
      {loading ? (
        <p className="text-gray-600 mt-4 text-center border border-gray-300  py-24 text-lg rounded-md">
          {t("Loading...")}
        </p>
      ) : data?.length === 0 ? (
        <p className="text-gray-600 mt-4 text-center border border-gray-300  py-24 text-lg rounded-md">
          {t("No Data Available")} !
        </p>
      ) : (
        <div
          className={`overflow-x-auto relative  mt-4 bg-white p-3 rounded-lg `}
        >
          <table
            className={`w-full whitespace-nowrap  text-sm   ${
              isRTL ? "text-right" : "text-left"
            }`}
          >
            <thead className="text-md text-gray-500  bg-slate-100  font-normal">
              <th className=" px-4 py-4">{t("Name")}</th>
              <th className=" px-4 py-4">{t("Email")}</th>
              <th className=" px-4 py-4">{t("Phone")}</th>
              <th className=" px-4 py-4">{t("Subject")}</th>
              <th className=" px-4 py-4">{t("National Id")}</th>
              <th className=" px-4 py-4">{t("Date")}</th>
              <th className=" px-4 py-4">{t("Nature Of Communication")}</th>
              <th className=" px-4 py-4">{t("Message")}</th>
            </thead>
            <tbody
              className={`text-gray-500 ${language === "ar" && "text-lg"}`}
            >
              {data?.map((applicant, k) => (
                <tr
                  key={applicant._id}
                  className={`odd:bg-white even:bg-gray-50 ${
                    k % 2
                      ? "bg-gray-50 dark:bg-gray-600"
                      : "bg-white dark:bg-gray-700"
                  }}`}
                >
                  <td
                    className={`border-b border-gray-300 px-4 py-4 ${
                      isArabic(applicant.name) ? " Majalla text-lg" : ""
                    }`}
                  >
                    {applicant.name}
                  </td>
                  <td
                    className={`border-b border-gray-300 px-4 py-4 ${
                      isArabic(applicant.email) ? " Majalla text-lg" : ""
                    }`}
                  >
                    {applicant.email}
                  </td>
                  <td
                    className={`border-b border-gray-300 px-4 py-4 ${
                      isArabic(applicant.phone) ? " Majalla text-lg" : ""
                    }`}
                  >
                    {applicant.phone}
                  </td>
                  <td
                    className={`border-b border-gray-300 px-4 py-4 ${
                      isArabic(applicant.subject) ? " Majalla text-lg" : ""
                    }`}
                  >
                    {applicant.subject}
                  </td>
                  <td
                    className={`border-b border-gray-300 px-4 py-4 ${
                      isArabic(applicant.nationalId) ? " Majalla text-lg" : ""
                    }`}
                  >
                    {applicant.nationalId}
                  </td>

                  <td
                    className={`border-b border-gray-300 px-4 py-4 ${
                      isArabic(applicant.createdAt) ? " Majalla text-lg" : ""
                    }`}
                  >
                    {moment(applicant.createdAt).format("LLL")}
                  </td>
                  <td
                    className={`border-b border-gray-300 px-4 py-4 ${
                      isArabic(applicant.natureOfCommunication)
                        ? " Majalla text-lg"
                        : ""
                    }`}
                  >
                    {applicant.natureOfCommunication}
                  </td>
                  <td
                    className={`border-b border-gray-300 px-4 py-4 max-w-[800px] min-w-[500px] whitespace-normal break-normal  ${
                      isArabic(applicant.message) ? " Majalla text-lg" : ""
                    }`}
                  >
                    {applicant?.message}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default CustomerQueries;
